import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const blocks = document.querySelectorAll('.block-testimonial-cards');

if (blocks.length > 0) {
	blocks.forEach((block) => {
		const slider = block.querySelector('.block-testimonials .swiper');

		if (!slider) {
			return;
		}

		let cardsPerRow = 4;

		if (block.hasAttribute('data-cards-per-row')) {
			cardsPerRow = parseInt(block.getAttribute('data-cards-per-row'));
		}

		let spaceBetweenCards = 32;

		if (cardsPerRow === 4) {
			spaceBetweenCards = 16;
		}

		const slides = slider.querySelectorAll('.swiper-slide');

		const settings = {
			loop: true,
			grabCursor: false,
			spaceBetween: spaceBetweenCards,
			slidesPerView: 1,
			centeredSlides: true,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			pagination: {
				el: slider.parentElement.querySelector('.swiper-pagination'),
				clickable: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2.1,
					loop: slides.length > 2 ? true : false,
				},
				992: {
					slidesPerView: 4.1,
					loop: true,
				},
				1400: {
					slidesPerView: 4.1,
					loop: true,
				},
				1760: {
					slidesPerView: 3.4,
					loop: true,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
